import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateLogin } from "../utils/auth";

export default function LoginForm({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [failedOnce, setFailedOnce] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const user = await validateLogin(username, password);
      if (!user) {
        setMessage("Felaktigt användarnamn eller lösenord, eller låst konto.");
        setFailedOnce(true);
        return;
      }
      setMessage("Inloggning lyckades!");
      setFailedOnce(false);
      if (onLogin) onLogin(user);
      // Här kan du navigera vidare, t.ex. till en dashboard
      // navigate("/dashboard");
    } catch (err) {
      setMessage("Ett tekniskt fel uppstod.");
    }
  };

  return (
    <div className="app-wrapper login-form-centered">
      <h2>Logga in</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">Användarnamn</label>
          <input
            id="username"
            type="text"
            placeholder="Användarnamn"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </div>

        <div>
          <label htmlFor="password">Lösenord</label>
          <input
            id="password"
            type="password"
            placeholder="Lösenord"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit">Logga in</button>
      </form>

      {failedOnce && (
        <button
          style={{ marginTop: "1rem", backgroundColor: "#555" }}
          onClick={() => navigate("/reset-password")}
        >
          Återställ lösenord
        </button>
      )}

      {message && (
        <div
          style={{
            color: message.includes("lyckades") ? "green" : "red",
            marginTop: "1rem"
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
}
